import { getVertexTypeInNetwork, TYPE_VERTEX } from '@/shared/constants/ds-constants';
import { CmGroupStatus as CmGroupStatus } from './cm-groupStatus.model';
import { ConnectomeNode } from './connectome-node.model';

export class CmGroupsQueueMessage {
  connectomeId: string = null;
  groupId: string = null;
  collectionId: string = null;
  lang: string = null;
  status: CmGroupStatus = null;
  requestId: string = null;
  titleCompleteMessage: any = null;
  scrapBoardList: Array<any> = null;
  failScrapList: Array<any> = null;

  constructor(element: any) {
    if (element) {
      this.groupId = element.collectionId;
      this.connectomeId = element.connectomeId || element.userKey;
      this.collectionId = element.collectionId;
      this.lang = element.lang;
      this.requestId = element.requestId;
      this.titleCompleteMessage = element.titleCompleteMessage;
      this.scrapBoardList = element.scrapBoardList;
      this.failScrapList = element.failScrapList;
      this.status = element.status || element.code ? Object.assign({}, element.status) : null;
      if (element.code) {
        this.status.code = element.code;
      }
    }
  }
}
